// removed by extract-text-webpack-plugin
module.exports = {"classInput":"InputForm-classInput-fc300199"};


//////////////////
// WEBPACK FOOTER
// ./src/themes/defaults/sass/components/InputForm.scss
// module id = 907
// module chunks = 0